import { PostList } from './PostList';

export abstract class Post {
  abstract readonly id: string;
  abstract readonly content: string;
  abstract readonly username: string;
  abstract readonly timestamp: Date;
  abstract hasChildren(): boolean;
  abstract readonly postList: PostList<Post>;
  abstract toPlainObject(): Object;
  abstract readonly ymd: string;
  abstract readonly hi: string;
  abstract readonly responseCount: number;
  abstract readonly lastUpdate: Date;
}

export interface DummyPlainObject {
  [key: string]: any;
}